if($('.hero-video').length) {

    $(".hero-video").each(function () {

        let heroVideoObject = document.createElement('video'),
            heroVideoContainer = $(this),
            heroMp4File = heroVideoContainer.find('.video-mp4'),
            heroMp4FileMobile = heroVideoContainer.find('.video-mp4-mobile'),
            heroWebmFile = heroVideoContainer.find('.video-webm'),
            heroWebmFileMobile = heroVideoContainer.find('.video-webm-mobile');

        if (heroMp4FileMobile.length && $(window).width() < 768) {
            let sourceMP4 = document.createElement("source");
            sourceMP4.type = "video/mp4";
            sourceMP4.src = heroMp4FileMobile.val();
            heroVideoObject.appendChild(sourceMP4);
        } else {
            if (heroMp4File.length) {
                let sourceMP4 = document.createElement("source");
                sourceMP4.type = "video/mp4";
                sourceMP4.src = heroMp4File.val();
                heroVideoObject.appendChild(sourceMP4);
            }
        }

        if (heroWebmFileMobile.length && $(window).width() < 768) {
            let sourceWebM = document.createElement("source");
            sourceWebM.type = "video/webm";
            sourceWebM.src = heroWebmFileMobile.val();
            heroVideoObject.appendChild(sourceWebM);
        } else {
            if (heroWebmFile.length) {
                let sourceWebM = document.createElement("source");
                sourceWebM.type = "video/webm";
                sourceWebM.src = heroWebmFile.val();
                heroVideoObject.appendChild(sourceWebM);
            }
        }

        heroVideoObject.autoplay = false;
        heroVideoObject.muted = true;
        $(heroVideoObject).attr('webkit-playsinline', '');
        $(heroVideoObject).attr('playsinline', '');
        heroVideoObject.playsinline = true;
        heroVideoObject.loop = true;
        heroVideoObject.load();

        // Add the video to the DOM
        heroVideoContainer.find('.video-container').append(heroVideoObject);

        // Attempt to play the video
        var playPromise = heroVideoObject.play();

        if (playPromise !== undefined) {
            playPromise.then(function () {
                console.log('playing');
            }).catch(function (error) {
                console.log(error);
                console.log('error playing');
            });
        }

        // Set up the video control functionality for this specific video
        const videoContainer = heroVideoContainer.find('.video-container');

// Toggle play/pause controls when clicking the container
        videoContainer.click(function() {
            const playButton = $(this).find('.video-play');
            const pauseButton = $(this).find('.video-pause');

            // Toggle the 'current' class for both buttons
            playButton.toggleClass('current');
            pauseButton.toggleClass('current');

            // Play or pause based on which button is now active
            if (pauseButton.hasClass('current')) {
                // The pause button is visible, so the video should be playing
                heroVideoObject.play();
            } else {
                // The play button is visible, so the video should be paused
                heroVideoObject.pause();
            }
        });

// Pause button functionality
        heroVideoContainer.find('.video-pause').click(function(e) {
            e.stopPropagation(); // Prevent triggering the container click

            // Pause the video
            heroVideoObject.pause();

            // Update the button states - show the play button
            $(this).removeClass('current');
            heroVideoContainer.find('.video-play').addClass('current');
        });

// Play button functionality
        heroVideoContainer.find('.video-play').click(function(e) {
            e.stopPropagation(); // Prevent triggering the container click

            // Play the video
            heroVideoObject.play();

            // Update the button states - show the pause button
            $(this).removeClass('current');
            heroVideoContainer.find('.video-pause').addClass('current');
        });
    });
}
$(document).ready(function() {
    // Play button click handler
    $('.video-play').click(function() {
        // $(this).addClass('current');  // Commented out as per your example
        $('.video-play').removeClass('current');
        $('.video-pause').addClass('current');
    });

    // Pause button click handler
    $('.video-pause').click(function() {
        console.log('test');
        $('.video-play').addClass('current');
        $('.video-pause').removeClass('current');
    });
});